















import { Vue, Component } from 'vue-property-decorator';
import AList from './a-list.vue';
@Component({
  components: { AList }
})
export default class UnitDashboard extends Vue {
  bread = [{ name: '板块部门指标运营驾驶仓' }, { name: '板块部门运营仪表盘' }];

  confList = [
    { title: '渠道板块', number: 11 },
    { title: '市场板块', number: 15 },
    { title: '风险板块', number: 25 },
    { title: '运营板块', number: 15 }
  ];
}
